<template>
  <div class="reset-pass" v-if="info && info.mobile">
    <div :class="['content']">
      <h1>修改密码</h1>
      <div class="set-module">
        <div class="dialog-box">
          <p class="text-info" :style="{ margin: '0 0 16px' }">
            {{
              `通过手机号 ${
                info.mobile
                  ? `${info.mobile.slice(0, 3)}***${info.mobile.slice(-4)}`
                  : ""
              } 验证`
            }}
          </p>
          <div class="form-box">
            <t-space style="width: 354px">
              <t-form :data="formData" ref="form" :labelWidth="0">
                <t-form-item
                  name="code"
                  :style="{ marginBottom: '24px' }"
                  :rules="[
                    {
                      required: true,
                      message: '动态验证码不能为空',
                      trigger: 'blur',
                    },
                    {
                      min: 6,
                      max: 6,
                      message: '验证码不正确',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <div class="code-box">
                    <t-input
                      v-model="formData.code"
                      placeholder="请输入验证码"
                    ></t-input>
                    <div
                      class="get-code"
                      :style="{
                        color:
                          codeBtnVal != '获取验证码' ? '#4E5969' : '#165DFF',
                      }"
                      @click="openImgCode"
                    >
                      {{ codeBtnVal }}
                    </div>
                  </div>
                </t-form-item>
                <t-form-item
                  name="password"
                  :style="{ marginBottom: '24px' }"
                  :rules="[
                    {
                      required: true,
                      message: '请输入数字、字母、符号(_-@&=.)组合的8-18位新密码',
                      trigger: 'blur',
                    },
                    {
                      pattern:
                        /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[_\-@&=.])[a-zA-Z0-9_\-@&=.]{8,18}$/i,
                      message: '必须为8-18位数字、字母、常用符号(_-@&=.)组合',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <t-input
                    type="password"
                    v-model="formData.password"
                    placeholder="数字、字母、符号(_-@&=.)组合的8-18位新密码"
                  ></t-input>
                </t-form-item>
                <t-form-item
                  name="morePassword"
                  :style="{ marginBottom: '24px' }"
                  :rules="[
                    {
                      required: true,
                      message: '请再次输入新密码',
                      trigger: 'blur',
                    },
                    {
                      validator: (val) => val === formData.password,
                      message: '两次密码不一致！',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <t-input
                    type="password"
                    v-model="formData.morePassword"
                    placeholder="请再次输入新密码"
                  ></t-input>
                </t-form-item>
                <div class="btn-box">
                  <div class="btn" @click="setConfirmFun">确定</div>
                </div>
              </t-form>
            </t-space>
          </div>
        </div>

        <t-dialog
          theme="info"
          header="提示"
          width="400"
          placement="center"
          body="根据《中华人民共和国网络安全法》要求，使用互联网服务需要进行身份信息验证。请先绑定手机号验证，感谢你的支持和理解。"
          :visible.sync="visible"
          @confirm="confirmFun"
          :closeOnOverlayClick="false"
          :destroyOnClose="true"
          :cancelBtn="null"
          :confirmBtn="'知道了'"
        ></t-dialog>
      </div>
    </div>
    <!--滑块验证-->
    <slider-verify
      ref="sliderVerify"
      @closeDialog="closeDialog"
      @success="onSuccess"
      v-if="pwdFlag"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { getDynamicCode, isAlive, postInitPassword } from "@/../api";
import sliderVerify from "@/components/common/puzzleVerify";
import { zhugeTrack, jumpAfterLogin, getQueryString } from "@/utils/utils";
export default {
  name: "",
  data() {
    return {
      codeBtnVal: "获取验证码",
      timer: null,
      visible: false, // 提示弹框
      setVisible: true, // 设置弹框
      editFlag: false,
      codeLoading: false, // 验证码发送中
      submitPhoneLoading: false, // 手机修改密码中
      pwdFlag: false,
      formData: {
        code: "",
        password: "",
        morePassword: "",
      },
      info: {},
      referUrl: "",
    };
  },
  components: {
    sliderVerify,
  },
  watch: {
    sliderResult: {
      handler(val) {
        if (val) {
          this.getCode(val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState(["sliderResult"]),
  },
  mounted() {
    // 获取登录页跳转的页面
    this.referUrl = getQueryString("refer")
      ? decodeURIComponent(getQueryString("refer"))
      : "";
    this.getInfo();
  },
  metaInfo() {
    return {
      title:'修改密码 - 传智杯大赛官网-全国大学生计算机应用能力与数字素养大赛',
      meta: [
        {
          name: "keyWords",
          content: "修改密码,入口,学习中心,账号,登录,密码,修改,博学谷",
        },
        {
          name: "description",
          content:
            "博学谷修改密码入口，学员忘记学习账号登录密码，可以通过此入口重置密码，修改登录密码后可以重新登录学习账号，在线学习所报名的视频课程或视频教程，如修改密码失败可咨询客服老师或拨打客服电话：010-5628 8220。",
        },
      ],
      link: [{ rel: "icon", type: "image/x-icon", href: '/favicon.czb.ico'}]
    };
  },
  methods: {
    ...mapMutations(["isShowSliderVerifyHandle", "sliderResultHandle"]),
    async getInfo() {
      const res = await isAlive();

      if (res.data && res.data.success) {
        this.info = res.data.resultObject;
        this.currName = this.info.name;
      } else {
        jumpAfterLogin(this.referUrl);
      }
    },

    editFun() {
      if (this.info.status == 2) {
        this.$message.error("注销待审核期间不可进行此操作！");
        return;
      }
      if (!this.info.hasPWD) {
        zhuge.track("点击_账号设置页_按钮", {
          终端: "Web",
          按钮名称: "设置密码",
        });
        this.editFlag = false;
        this.setVisible = true;
      } else {
        zhuge.track("点击_账号设置页_按钮", {
          终端: "Web",
          按钮名称: "修改密码",
        });
        if (this.info.mobile) {
          this.editFlag = true;
          this.setVisible = true;
        } else {
          this.visible = true;
        }
      }
    },
    // 关闭提示弹框
    confirmFun() {
      this.visible = false;
    },
    // 通过手机修改密码确认
    async setConfirmFun() {
      if (this.submitPhoneLoading) return;
      if ((await this.$refs.form.validate()) === true) {
        const params = {
          password: this.formData.morePassword,
          code: this.formData.code,
        };
        this.submitPhoneLoading = true;
        const r = await postInitPassword(params);
        let res = r.data;
        if (res.code === 200) {
          this.$message.success(
            this.editFlag
              ? "密码修改成功，请重新登录"
              : "密码设置成功，请重新登录"
          );
          this.closeFun();
          setTimeout(async () => {
            const re = await isAlive();
            let data = re.data;
            if (!data.success) {
               this.$router.push({
                  name: "login",
                  query: {
                    refer: this.referUrl ? this.referUrl : undefined
                  },
                });
              
            }else{
              // 登录成功后的跳转
              jumpAfterLogin(this.referUrl);
            }
          }, 1500);
        } else if (res.code === 401) {
          this.$message.error(res.desc);
          this.$router.push({
            name: "login",
            query: {
              refer: this.referUrl ? this.referUrl : undefined
            },
          });
        } else {
          this.$message.error(res.desc);
        }
      }
      this.submitPhoneLoading = false;
    },
    // 绑定手机关闭
    closeFun() {
      this.setVisible = false;
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.$refs.form.clearValidate();
      }
      clearInterval(this.timer);
      this.codeBtnVal = "获取验证码";
      this.codeLoading = false;
      this.submitPhoneLoading = false;
    },
    // 打开拼图验证码
    async openImgCode() {
      if (this.codeLoading || this.codeBtnVal != "获取验证码") return;
      this.pwdFlag = true;
      this.$nextTick(() => {
        this.isShowSliderVerifyHandle(true);
      });
    },
    // 关闭拼图验证码
    closeDialog() {
      this.pwdFlag = false;
    },
    // 滑动验证成功
    onSuccess() {
      this.pwdFlag = false;
    },
    // 获取手机验证码
    async getCode(validCode) {
      if (this.codeLoading || this.codeBtnVal != "获取验证码") return;
      this.codeLoading = true;
      const params = {
        mobileOrEmail: this.info.mobile,
        vType: 1,
        messageType: 1,
        validCode: validCode,
      };
      this.codeBtnVal = "发送中...";
      this.sliderResultHandle(false); //清空拼图操作结果
      let r = await getDynamicCode(params);
      let res = r.data;
      if (res.code === 200) {
        this.codeLoading = false;
        let num = 60;
        this.timer = setInterval(() => {
          if (num <= 0) {
            clearInterval(this.timer);
            this.codeBtnVal = "获取验证码";
            this.codeLoading = false;
          } else {
            this.codeBtnVal = num-- + "s";
          }
        }, 1000);
      } else {
        this.$message.error(res.desc);
        clearInterval(this.timer);
        this.codeBtnVal = "获取验证码";
        this.codeLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1280px) {
  .content {
    right: 120px !important;
  }
}

@media screen and (min-width: 1920px) {
  .content {
    right: 440px !important;
  }
}

@media screen and (min-width: 1281px) and (max-width: 1919px) {
  .content {
    right: 200px !important;
  }
}

.reset-pass {
  ::v-deep input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  .t-message {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1d2129;
    width: max-content;
    height: 48px;
    background: #ffffff;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08),
      0px 3px 6px -4px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    border: 1px solid #e5e6eb;
  }

  .contentheight1 {
    height: 520px;
  }

  .contentheight2 {
    height: 660px !important;
  }

  .content {
    width: 464px;
    height: 520px;
    background: #ffffff;
    box-shadow: 0px 12px 40px 16px rgba(8, 25, 93, 0.03),
      0px 8px 20px 0px rgba(8, 25, 93, 0.06),
      0px 4px 8px 0px rgba(8, 25, 93, 0.08);
    border-radius: 8px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 200px;
    box-sizing: border-box;

    h1 {
      height: 32px;
      font-size: 24px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 32px;
      margin: 48px auto 24px;
      text-align: center;
    }

    .tab-check {
      display: flex;
      padding-left: 48px;
    }

    .p1 {
      height: 24px;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 600;
      color: #165dff;
      cursor: pointer;

      &::after {
        content: "";
        width: auto;
        height: 3px;
        background: #165dff;
        border-radius: 4px 4px 0px 0px;
        display: block;
        margin-top: 7px;
      }
    }

    .p2 {
      height: 24px;

      cursor: pointer;
      border-radius: 4px 4px 0px 0px;
      margin-right: 32px;
      line-height: 24px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;

      color: #4e5969;

      &:hover {
        color: #165dff;
      }
    }
  }

  ::v-deep .form-box {
  

    .el-form-item {
      margin-bottom: 24px;
    }
    // input
    .t-input {
      padding: 0 16px;
      border-color: #e5e6eb;
      .t-input__inner {
        color: #1d2129 !important;
        &::placeholder {
          color: #86909c !important;
        }
      }
      .t-input__suffix {
        .t-icon-browse {
          width: 16px;
          height: 16px;
          background-image: url(../assets/icon-preview-open.png);
          background-size: 100% 100%;
          path {
            display: none;
          }
        }
        .t-icon-browse-off {
          width: 16px;
          height: 16px;
          background-image: url(../assets/icon-preview-close.png);
          background-size: 100% 100%;
          path {
            display: none;
          }
        }
      }
      &:focus {
        border-color: #165dff !important;
      }
      &:hover {
        border-color: #165dff !important;
      }
    }
    .el-input__inner {
      width: 368px;
      height: 40px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 4px;
      line-height: 40px;
      padding-left: 16px;
      box-sizing: border-box;
      border: 1px solid #e5e6eb;

      &:focus {
        border: 1px solid #4080ff;
      }
    }

    .is-error {
      .el-input__inner {
        border: 1px solid #ff4012;
      }

      .el-form-item__error {
        color: #ff4012;
        padding-top: 0px;
        height: 20px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #f53f3f;
        line-height: 20px;
      }
    }
  }
}
.dialog-box {
  ::v-deep .el-dialog__wrapper {
    z-index: 2003 !important;
  }
  .btn-box {
    width: 368px;
    height: 44px;
    border-radius: 4px;
    margin-top: 33px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;

    letter-spacing: 0;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
    background-color: #4080ff;

    p:nth-child(2) {
      height: 40px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #86909c !important;
      line-height: 20px;
      position: relative;
      padding-left: 8px;
      margin-top: 16px;
      color: red;
      text-align: left;

      &::before {
        content: "*";
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 20px;
        position: absolute;
        top: 0;
        left: -5px;
      }
    }

    .btn {
      color: #ffffff;
    }

    &:hover {
      background: #165dff;
    }

    .p1 {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      text-align: center;
      margin-top: 24px;

      span {
        color: #4e5969;
        cursor: pointer;

        &:hover {
          color: #165dff !important;
        }
      }
    }
  }
  .get-code {
    width: 112px;
    height: 40px;
    background: #e8f3ff;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4e5969;
    line-height: 40px;
    text-align: center;
    margin-left: 16px;
    cursor: pointer;

    &:hover {
      color: #165dff;
      background: #e8eeff;
    }
  }
  .tab-check {
    width: 144px;
    margin: 0 auto 24px;
    display: flex;
    justify-content: space-between;
    position: relative;
    .tab {
      padding: 0 0 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #4e5969;
      line-height: 22px;
      cursor: pointer;
    }
    .tab-active {
      color: #165dff;
    }
    .tab-line {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 56px;
      height: 2px;
      background: #165dff;
      border-radius: 4px 4px 0px 0px;
      transition: left 0.1s linear;
    }
  }

  .text-info {
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #1d2129;
    line-height: 22px;
  }
  .form-box {
    margin-top: 18px;
    ::v-deep .t-space {
        display: block;
        margin: 0 auto;
      
    }
  }
  .code-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  ::v-deep .t-input__wrap {
    flex: 1;

    .t-input {
      height: 40px;
    }
  }
}

// 邮件发送成功
.bind-success {
  text-align: center;
  padding-top: 34px;

  .img-mask {
    width: 48px;
    height: 48px;
    margin: 0 auto;
    background: #e8f3ff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
    }
  }

  p {
    margin: 16px 0 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #86909c;
    line-height: 22px;
    text-align: center;
  }

  .toEmail {
    display: block;
    margin: 0 auto;
    width: 80px;
    margin-bottom: 30px;
    padding: 0;
    text-align: center;
  }
}
</style>